/* Stabiele React-keys voor bewerkbare rij-lijsten.
   `_key` blijft lokaal (UI-state) en wordt vóór opslaan gestript. */
let _teller = 0;
export const nieuweRijKey = () => `rk-${++_teller}`;
export const metKeys = (rows) => (rows || []).map((r) => (r && r._key ? r : { ...r, _key: nieuweRijKey() }));
export const zonderKeys = (rows) => (rows || []).map(({ _key, ...rest }) => rest);
